
import { Box, Grid2, Typography } from "@mui/material";
import { addDays, isPast, isSameDay } from "date-fns";
import format from "date-fns/format";
import React from "react";

import { useDateFnsLocale } from "../../../../utils/date-locale";
import useFullTimeShiftsData from "../../controllers/use-full-time-shifts-data";
const BORDER_COLOR = "#E5E5E5";

export const CalendarHeader = () => {

  const dateLocale = useDateFnsLocale();
  const { currentDate, startingDay } = useFullTimeShiftsData();

  return (
    <Grid2
      container
      width={"100%"}
      sx={{
        flexGrow: 1,
      }}
    >
      {/* Day headers */}
      <Grid2
        container
        width={"100%"}
        sx={{
          position: "sticky",
          top: 0,
          height: "64px",
          minHeight: "64px",
          backgroundColor: "rgba(255,255,255)",
          boxShadow: "0px 2px 4px -2px rgba(0, 0, 0, 0.2)",
          flexWrap: "nowrap",
          zIndex: 1000,
        }}
      >
        {/* Days container */}
        <Box
          sx={{
            display: "flex",
            flex: 1,
            height: "100%",
          }}
        >
          {currentDate &&
            Array.from({ length: 7 }).map((_, index) => {
              const day = addDays(startingDay, index);
              return (
                <React.Fragment key={index}>
                  <Box
                    sx={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      textAlign: "center",
                      height: "100%",
                      position: "relative",
                      paddingLeft: "0.8rem",
                      borderRight: index !== 6 ? `1px solid ${BORDER_COLOR}` : "1px solid transparent",
                      borderTop: `1px solid ${BORDER_COLOR}`,
                      //	borderBottom: `1px solid ${BORDER_COLOR}`,
                      backgroundColor: isSameDay(day, new Date())
                        ? "rgba(47, 77, 139, 0.04)"
                        : isPast(day) ? "rgba(0,0,0,0.02)" : "",
                      width: "172px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "16px",
                          lineHeight: "28px",
                          fontWeight: 400,
                          fontFamily: "Roboto",
                          color: isSameDay(day, new Date())
                            ? "#2F4D8B"
                            : "rgba(0,0,0,0.6)",
                          marginRight: "0.5rem",
                        }}
                      >
                        {format(day, "EEE", { locale: dateLocale })}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "24px",
                          lineHeight: "32px",
                          fontWeight: 400,
                          fontFamily: "Roboto",
                          color: isSameDay(day, new Date())
                            ? "#2F4D8B"
                            : "rgba(0,0,0,0.6)",
                        }}
                      >
                        {format(day, "d")}
                      </Typography>
                    </Box>
                  </Box>
                </React.Fragment>
              );
            })}
        </Box>
      </Grid2>
    </Grid2>
  );
};
